
<template>
  <div v-if="formatter.config">
    <ag-sub-input
      ref="text"
      :initText="formatter.config.text"
      :type="'textarea'"
      :workflow="workflow"
      :placeholder="'Set to...'"
      :rows="5"
      :maxRows="15"
      :noResize="true"
      :disabled="disableUI"
    ></ag-sub-input>
  </div>
</template>






<script>
// components
import SubInput from "comp/ui/SubInput";

// modules

export default {
  name: "ag-hashFormatter",
  components: {
    "ag-sub-input": SubInput
  },
  props: {
    disableUI: Boolean,
    formatter: Object,
    workflow: Object
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},

  created() {},

  mounted() {
    this.reset();
  },

  methods: {
    // UI Events

    // emitted Events

    // other

    reset() {
    },

    prepareForSave() {
      this.formatter.config.text = this.$refs["text"].text;
    }
  }
};
</script>






<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/nodes/formatters/HashFormatter.vue